import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

// Import the generated route tree
import { routeTree } from './routeTree.gen';
import { AuthStore } from './authStore';
import { BallotStore } from './ballotStore';

const authStore = new AuthStore();
export const getAuthStore = () => authStore;

getAuthStore().fetchUser();
getAuthStore().fetchUserDoc();

const ballotStore = new BallotStore();
export const getBallotStore = () => ballotStore;

// Create a new router instance
const router = createRouter({ routeTree, scrollRestoration: true });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}
